import React from "react";

import s from "./resize-div.module.scss";

const sDisable = s.disable;
if (sDisable === undefined) throw Error("disable class is not defined");

const root = document.documentElement;
const maxX = root.clientWidth - 320;
const minX = 320;

const normalizeX = (input: number) => {
    let x = input;
    x = Math.min(x, maxX);
    x = Math.max(x, minX);
    return x;
};

interface Props {
    setWidth: (width: number) => void;
}

export const ResizeDiv: React.FC<Props> = ({ setWidth }) => {
    const [isDragging, setIsDragging] = React.useState(false);

    const doDrag = React.useCallback(
        (e: MouseEvent) => {
            const clientX = normalizeX(e.clientX);
            setWidth(clientX / root.clientWidth);
        },
        [setWidth]
    );

    const stopDrag = React.useCallback(() => {
        root.classList.remove(sDisable);
        root.removeEventListener("mousemove", doDrag);
        root.removeEventListener("mouseup", stopDrag);
        setIsDragging(false);
    }, [doDrag, setWidth]);

    const startDrag = React.useCallback(() => {
        root.classList.add(sDisable);
        root.addEventListener("mousemove", doDrag);
        root.addEventListener("mouseup", stopDrag);
        setIsDragging(true);
    }, [doDrag, stopDrag]);

    return (
        <div
            className={`${s.container} ${isDragging ? s.drag : s.noDrag}`}
            onMouseDown={startDrag}
            onDoubleClick={() => setWidth(0.5)}
        >
            <div className={s.line} />
        </div>
    );
};
